const styles = theme => ({
  claim: {
    display: 'grid',
    gridTemplateColumns: '60px 9fr 1fr 2fr',
    gridTemplateRows: '30px 30px 20px 20px',
    marginBottom: '10px',
    fontFamily: 'Roboto, sans-serif',
    backgroundColor: '#FFF',
  },
  claimExpanded: {
    gridTemplateRows: '60px 140px 60px 25px 25px',
    '& $claimBackground': {
      gridRow: '3 / 4',
    },
    '& $dayCounter': {
      gridRow: '1 / 2',
    },
    '& $number': {
      gridRow: '4 / 6',
    },
    '& $title': {
      paddingLeft: 30,
      backgroundColor: '#029AB1',
      color: '#FFF',
      fontSize: '1.3rem',
    },
    '& $description': {
      paddingTop: 15,
      paddingLeft: 10,
      justifyContent:'start',
      fontSize: '1.1em',
      alignItems:'flex-start',
      textAlign:'left',
      fontWeight:'300',
      overflow:'auto',
    },
    '& $maternity': {
      gridRow: '4 / 5',
    },
    '& $reason': {
      backgroundColor: '#029AB1',
      alignItems: 'flex-start',
      paddingTop: 15,
    },
    '& $date': {
      gridRow: '4 / 5',
    },
    '& $time': {
      gridRow: '5 / 6',
    },
    '& $doctor': {
      gridRow: '5 / 6',
    },
  },
  claimBackground: {
    gridColumn: '1 / 5',
    gridRow: '2 / 3',
    justifyContent:'center',
    borderBottom: '1px solid #CCC',
  },
  title: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gridColumn: '2 / 3',
    gridRow: '1 / 2',
    paddingLeft: 20,
    fontSize: '1.2rem',
    color: '#444',
  },
  dayCounter: {
    gridColumn: '1 / 2',
    gridRow: '1 / 3',
    color: '#FFF',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '1.3rem',
    backgroundColor: '#029AB1',
    textTransform: 'none',
  },
  number: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gridColumn: '1 / 2',
    gridRow: '3 / 5',
    fontSize: '1.3rem',
    fontWeight: 700,
    backgroundColor: '#D8D8D8',
  },
  description: {
    gridColumn: '2 / 4',
    gridRow: '2 / 3',
    paddingLeft: 20,
    color: '#444',
    justifyContent: 'flex-start',
    fontWeight: 900,
    fontSize: '1.4rem'
  },
  buttons: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gridAutoFlow: 'row',
    gridColumnGap: '20px',
    alignItems: 'center',
    gridColumn: '1 / 5',
    gridRow: '3 / 4',
    paddingLeft: '5%',
    paddingRight: '5%',
  },
  buttonsResolve: {
    width: 40,
    height: 40,
    color: '#646464',
    backgroundColor: '#FFF',
  },
  buttonClose: {
    maxWidth: 160,
    width:85,
    height: 35,
    backgroundColor: '#029AB1',
    color:'#fff'
  },
  buttonDelete: {
    maxWidth: 160,
    width:85,
    height: 35,
    backgroundColor: '#FF0000',
    color:'#fff'
  },
  buttonsCall: {
    maxWidth: 160,
    height: 35,
    backgroundColor: '#FFF',
  },
  buttonsMessage: {
    maxWidth: 160,
    height: 35,
    color: '#FFF',
  },
  maternity: {
    display: 'flex',
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gridColumn: '2 / 3',
    gridRow: '3 / 4',
    paddingTop: 4,
  },
  maternityLabel: {
    paddingLeft: 6,
    paddingRight: 5,
    fontWeight: 100,
  },
  maternityValue: {
    fontWeight: 700,
    fontSize: '1.4rem',
  },
  doctor: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gridColumn: '2 / 3',
    gridRow: '4 / 5',
    paddingBottom: 4,
  },
  doctorLabel: {
    paddingLeft: 6,
    paddingRight: 5,
    fontWeight: 100,
  },
  doctorValue: {
    fontWeight: 700,
  },
  reason: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gridColumn: '3 / 5',
    gridRow: '1 / 2',
    paddingRight: 12,
  },
  reasonValue: {
    fontSize: '0.6rem',
    color: '#FFF',
    backgroundColor: '#616161',
    borderRadius: 2,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    letterSpacing: 0.2,
  },
  date: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gridColumn: '4 / 5',
    gridRow: '3 / 4',
    paddingTop: 4,
    paddingRight: 12,
    color: '#666',
    fontWeight: 100,
    fontSize: '0.8rem',
  },
  dateIcon: {
    fontSize: '1.2rem',
  },
  time: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gridColumn: '4 / 5',
    gridRow: '4 / 5',
    paddingBottom: 4,
    color: '#666',
    fontWeight: 100,
    fontSize: '0.8rem',
  },
  timeIcon: {
    fontSize: '1.2rem',
  },
});

export default styles;